import React from 'react';
import style from './style/Homestyle.module.css';

const Home = () => {
    return (
        <>
            <section className={style.body}>
                <div className={style.start}>
                    <h1>Welcome to Fashion World!!!</h1>
                </div>
            </section>

        </>
    )
}

export default Home;
